import {useState} from 'react';

export function useMenu() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  return {anchorEl, setAnchorEl};
}
